import { stationOpsApi } from "../config/apiConfig";

export const getStationsApi = async (operator) => {
  try {
    const endpoint = operator
      ? `/locations?operator=${operator}`
      : `/locations`;
    const response = await stationOpsApi.get(endpoint);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getStationDetails = async (id) => {
  try {
    const response = await stationOpsApi.get(`locations/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * The chargers a station actually has, or null when station-ops does not know the station.
 * Distinguishes "no such station" from "station with no chargers", which a caller validating
 * an identifier has to tell apart.
 */
export const getStationChargers = async (id) => {
  try {
    const response = await stationOpsApi.get(`locations/${encodeURIComponent(id)}`);
    return (response?.data?.evses ?? []).map((e) => e.uid).filter(Boolean);
  } catch (error) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
};
